var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"brand shadow-lg"},[_c('div',{staticClass:"float-right mt-3 mr-4"},[_c('h3',[_vm._v("wiitrade")])])])])
}]

export { render, staticRenderFns }